import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useApptAvailability(dtLocal, duration, excludeId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!dtLocal) { setData(null); return; }
    let cancel = false;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const params = { start: new Date(dtLocal).toISOString(), duration: parseInt(duration) || 30 };
        if (excludeId) params.exclude = excludeId;
        const res = await api.get("/appointments/availability", { params });
        if (!cancel) setData(res.data);
      } catch {
        if (!cancel) setData(null);
      } finally {
        if (!cancel) setLoading(false);
      }
    }, 400);
    return () => { cancel = true; clearTimeout(t); };
  }, [dtLocal, duration, excludeId]);
  return { data, loading };
}

function fmtIt(iso) {
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function ApptConflictBanner({ data }) {
  if (!data) return null;
  const { conflicts = [], google_conflicts = [], google_checked } = data;
  const has = conflicts.length > 0 || google_conflicts.length > 0;
  return (
    <div className="space-y-1.5">
      {has && (
        <div data-testid="appt-conflict-warning" className="rounded-md border border-amber-400 bg-amber-50 dark:bg-amber-500/10 p-2.5 text-xs text-amber-800 dark:text-amber-300">
          <div className="font-semibold">⚠️ Attenzione! Hai già un appuntamento programmato in questo orario.</div>
          <ul className="mt-1 space-y-0.5 list-disc pl-4">
            {conflicts.map((c, i) => (
              <li key={`c${i}`}>{fmtIt(c.start_at)} · {c.duration}min{c.lead_name ? ` · ${c.lead_name}` : ""}{c.title ? ` — ${c.title}` : ""}</li>
            ))}
            {google_conflicts.map((c, i) => (
              <li key={`g${i}`}>{fmtIt(c.start_at)} · Google Calendar{c.title ? ` — ${c.title}` : ""}</li>
            ))}
          </ul>
        </div>
      )}
      {!google_checked && (
        <div className="text-[11px] text-muted-foreground" data-testid="gcal-not-checked">
          Non è stato possibile controllare Google Calendar (non collegato o non disponibile): verificati solo gli appuntamenti interni.
        </div>
      )}
    </div>
  );
}
